/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
import type { FindAllSourceTags200ResponseDataInner } from './FindAllSourceTags200ResponseDataInner';
import {
    FindAllSourceTags200ResponseDataInnerFromJSON,
    FindAllSourceTags200ResponseDataInnerFromJSONTyped,
    FindAllSourceTags200ResponseDataInnerToJSON,
    FindAllSourceTags200ResponseDataInnerToJSONTyped,
} from './FindAllSourceTags200ResponseDataInner';
import type { FaxDocumentSenderSource } from './FaxDocumentSenderSource';
import {
    FaxDocumentSenderSourceFromJSON,
    FaxDocumentSenderSourceFromJSONTyped,
    FaxDocumentSenderSourceToJSON,
    FaxDocumentSenderSourceToJSONTyped,
} from './FaxDocumentSenderSource';
import type { InboundDocumentWorkStatus } from './InboundDocumentWorkStatus';
import {
    InboundDocumentWorkStatusFromJSON,
    InboundDocumentWorkStatusFromJSONTyped,
    InboundDocumentWorkStatusToJSON,
    InboundDocumentWorkStatusToJSONTyped,
} from './InboundDocumentWorkStatus';
import type { FaxDocumentReferralDeletedByUser } from './FaxDocumentReferralDeletedByUser';
import {
    FaxDocumentReferralDeletedByUserFromJSON,
    FaxDocumentReferralDeletedByUserFromJSONTyped,
    FaxDocumentReferralDeletedByUserToJSON,
    FaxDocumentReferralDeletedByUserToJSONTyped,
} from './FaxDocumentReferralDeletedByUser';

/**
 * 
 * @export
 * @interface FaxDocument
 */
export interface FaxDocument {
    /**
     * ID of the fax document
     */
    id: string;
    /**
     * Pointer to the document in S3
     */
    s3_key?: string;
    /**
     * Type of document
     */
    mime_type?: string;
    /**
     * The size of the fax
     */
    filesize_bytes?: number;
    /**
     * Number of pages in the fax document
     */
    page_count?: number;
    /**
     * Fax ID from the upstream API
     */
    external_fax_message_id: string;
    /**
     * Number who sent the fax
     */
    sender_fax_number: string;
    /**
     * Number who received the fax
     */
    receiver_fax_number: string;
    /**
     * Id of the lead the fax is associated with, if applicable
     */
    lead_id?: string;
    /**
     * 
     */
    sender_source?: FaxDocumentSenderSource;
    /**
     * 
     */
    receiver_facility?: FindAllSourceTags200ResponseDataInner;
    /**
     * When the fax was created (ISO)
     */
    date_created: Date;
    /**
     * When the fax was deleted (ISO)
     */
    date_deleted?: Date;
    /**
     * Whether or not the fax was successfully received
     */
    is_error: boolean;
    /**
     * Status of the fax with respect to referrals
     */
    referral_status?: FaxDocumentReferralStatusEnum;
    /**
     * 
     */
    referral_deleted_by_user?: FaxDocumentReferralDeletedByUser;
    /**
     * Whether or not the fax has been read by any user in the organization
     */
    is_read?: boolean;
    /**
     * Outcome of the fax's Inbound item: SPLIT, SENT_TO_SCREENER, or the folder it sits in. Omitted when the fax never reached Inbound.
     */
    inbound_result?: FaxDocumentInboundResultEnum;
    /**
     * Id of the fax's Inbound item while it sits in a folder; omitted once split or sent to Screener.
     */
    inbound_document_id?: string;
    /**
     * 
     */
    inbound_work_status?: InboundDocumentWorkStatus;
}


/**
 * @export
 */
export const FaxDocumentReferralStatusEnum = {
    ReferralCreated: 'REFERRAL_CREATED',
    ReferralDeleted: 'REFERRAL_DELETED',
    ReferralNotCreatedSpam: 'REFERRAL_NOT_CREATED_SPAM',
    ReferralNotCreatedSupportingDoc: 'REFERRAL_NOT_CREATED_SUPPORTING_DOC',
    Pending: 'PENDING',
} as const;
export type FaxDocumentReferralStatusEnum = typeof FaxDocumentReferralStatusEnum[keyof typeof FaxDocumentReferralStatusEnum];

/**
 * @export
 */
export const FaxDocumentInboundResultEnum = {
    Split: 'SPLIT',
    SentToScreener: 'SENT_TO_SCREENER',
    NeedsTriage: 'NEEDS_TRIAGE',
    Prescription: 'PRESCRIPTION',
    Orders: 'ORDERS',
    Auth: 'AUTH',
    Other: 'OTHER',
    Junk: 'JUNK',
} as const;
export type FaxDocumentInboundResultEnum = typeof FaxDocumentInboundResultEnum[keyof typeof FaxDocumentInboundResultEnum];


/**
 * Check if a given object implements the FaxDocument interface.
 */
export function instanceOfFaxDocument(value: object): value is FaxDocument {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('external_fax_message_id' in value) || value['external_fax_message_id'] === undefined) return false;
    if (!('sender_fax_number' in value) || value['sender_fax_number'] === undefined) return false;
    if (!('receiver_fax_number' in value) || value['receiver_fax_number'] === undefined) return false;
    if (!('date_created' in value) || value['date_created'] === undefined) return false;
    if (!('is_error' in value) || value['is_error'] === undefined) return false;
    return true;
}

export function FaxDocumentFromJSON(json: any): FaxDocument {
    return FaxDocumentFromJSONTyped(json, false);
}

export function FaxDocumentFromJSONTyped(json: any, ignoreDiscriminator: boolean): FaxDocument {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        's3_key': json['s3_key'] == null ? undefined : json['s3_key'],
        'mime_type': json['mime_type'] == null ? undefined : json['mime_type'],
        'filesize_bytes': json['filesize_bytes'] == null ? undefined : json['filesize_bytes'],
        'page_count': json['page_count'] == null ? undefined : json['page_count'],
        'external_fax_message_id': json['external_fax_message_id'],
        'sender_fax_number': json['sender_fax_number'],
        'receiver_fax_number': json['receiver_fax_number'],
        'lead_id': json['lead_id'] == null ? undefined : json['lead_id'],
        'sender_source': json['sender_source'] == null ? undefined : FaxDocumentSenderSourceFromJSON(json['sender_source']),
        'receiver_facility': json['receiver_facility'] == null ? undefined : FindAllSourceTags200ResponseDataInnerFromJSON(json['receiver_facility']),
        'date_created': (json['date_created'] == null ? json['date_created'] : parseDateTime(json['date_created'])),
        'date_deleted': json['date_deleted'] == null ? undefined : (parseDateTime(json['date_deleted'])),
        'is_error': json['is_error'],
        'referral_status': json['referral_status'] == null ? undefined : json['referral_status'],
        'referral_deleted_by_user': json['referral_deleted_by_user'] == null ? undefined : FaxDocumentReferralDeletedByUserFromJSON(json['referral_deleted_by_user']),
        'is_read': json['is_read'] == null ? undefined : json['is_read'],
        'inbound_result': json['inbound_result'] == null ? undefined : json['inbound_result'],
        'inbound_document_id': json['inbound_document_id'] == null ? undefined : json['inbound_document_id'],
        'inbound_work_status': json['inbound_work_status'] == null ? undefined : InboundDocumentWorkStatusFromJSON(json['inbound_work_status']),
    };
}

export function FaxDocumentToJSON(json: any): FaxDocument {
    return FaxDocumentToJSONTyped(json, false);
}

export function FaxDocumentToJSONTyped(value?: FaxDocument | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        's3_key': value['s3_key'],
        'mime_type': value['mime_type'],
        'filesize_bytes': value['filesize_bytes'],
        'page_count': value['page_count'],
        'external_fax_message_id': value['external_fax_message_id'],
        'sender_fax_number': value['sender_fax_number'],
        'receiver_fax_number': value['receiver_fax_number'],
        'lead_id': value['lead_id'],
        'sender_source': FaxDocumentSenderSourceToJSON(value['sender_source']),
        'receiver_facility': FindAllSourceTags200ResponseDataInnerToJSON(value['receiver_facility']),
        'date_created': value['date_created'] == null ? value['date_created'] : serializeDateTime(value['date_created']),
        'date_deleted': value['date_deleted'] == null ? value['date_deleted'] : serializeDateTime(value['date_deleted']),
        'is_error': value['is_error'],
        'referral_status': value['referral_status'],
        'referral_deleted_by_user': FaxDocumentReferralDeletedByUserToJSON(value['referral_deleted_by_user']),
        'is_read': value['is_read'],
        'inbound_result': value['inbound_result'],
        'inbound_document_id': value['inbound_document_id'],
        'inbound_work_status': InboundDocumentWorkStatusToJSON(value['inbound_work_status']),
    };
}

